import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_QuestionSurvey/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_QuestionSurvey/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_QuestionSurvey/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_QuestionSurvey/Update',
      data,
    });
  },
  Delete(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_QuestionSurvey/Delete',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  ChangeEnable(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_QuestionSurvey/ChangeEnable',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
};
